import {
  type SafeLandZoneEntity,
  type ZoneEntity,
  ZoneShapeType,
  ZoneType,
} from '@src/core/features';

/** Maps API safe-land zone to `ZoneEntity` for map, list, and selection state. */
export function safeLandZoneToZoneEntity(z: SafeLandZoneEntity): ZoneEntity {
  return {
    id: z.id,
    name: z.name,
    description: z.description,
    locationName: z.locationName,
    radiusMeters: 0,
    altitudeMeters: z.altitudeMeters,
    centerLatitude: z.centerLatitude,
    centerLongitude: z.centerLongitude,
    areaSquareMeters: 0,
    zoneType: ZoneType.TEMPORARY,
    shape: ZoneShapeType.CIRCLE,
    isActive: z.isActive,
    createdAt: z.createdAt,
    updatedAt: z.updatedAt,
    polygonCoordinates: [],
  };
}
